<template>
  <div class="bottom-switch expert-alliance-box">
    <div class="bottom-content clearfix">
      <div class="fl sign-pic"
           style='height: 326px;'
           v-if="tagsDataList.length">
        <a href="javascript:;"
           @click="$emit('emitHandleDetail',tagsDataList[0])"
           @contextmenu.stop.prevent="tagsDataList[0].others.length?$emit('emitContextMenuItem',0,$event):''"
           @touchstart="touchstarts(0)"
           @touchmove="touchmoves()"
           @touchend="touchends()">
          <!-- 秒杀 -->
          <!-- <div class="rightContent" v-if="items.discountTypes && seckillShow && items.endTime">
            <div>
              <span>秒杀特惠：￥<span style="fontSize:16px;">{{items.priceType}}</span></span>
            </div>
            <div>
              <span>距结束</span>
              <CountDown :endTime="items.endTime" @removeCon="removeCon"/>
            </div>
          </div> -->
          <ZImage :value="tagsDataList[0].pictures[0]?tagsDataList[0].pictures[0]:''"
                  :error-src="require('../../assets/image/images/default_media.png')" />
          <div class="pic-tit curr">
            <div class="tit"
                 v-if="tagsDataList[0].others.length">
              {{tagsDataList[0].others[0]?(allPrice(tagsDataList[0].others[0].standardEnName) ? formatPrice(tagsDataList[0].others[0].standardData) : tagsDataList[0].others[0].standardData):''}}
            </div>
            <div class="info"
                 v-if="tagsDataList[0].others.length">
              {{tagsDataList[0].others[1]?(allPrice(tagsDataList[0].others[1].standardEnName) ? formatPrice(tagsDataList[0].others[1].standardData) : tagsDataList[0].others[1].standardData):''}}
            </div>
            <div class="introduce"
                 v-if="tagsDataList[0].others.length">
              {{tagsDataList[0].others[2]?(allPrice(tagsDataList[0].others[2].standardEnName) ? formatPrice(tagsDataList[0].others[2].standardData) : tagsDataList[0].others[2].standardData):''}}
            </div>
          </div>
        </a>
      </div>
      <div class="fl rows"
           v-if="tagsDataList.length">
        <div class="row clearfix"
             v-for="(item,ind) in tagsDataList"
             :key="ind"
             v-show="ind>0&&ind<=maxIndShow"
             @click="$emit('emitHandleDetail',item)"
             @contextmenu="item.others.length?$emit('emitContextMenuItem',ind,$event):''"
             @touchstart="touchstarts(ind)"
             @touchmove="touchmoves()"
             @touchend="touchends()">
          <a href="javascript:;">
            <div class="fl pic">
              <ZImage :value="item.pictures[0]?item.pictures[0]:''"
                      :error-src="require('../../assets/image/images/default_media.png')" />
              <!-- <img :src="item.pictures[0]?item.pictures[0]:require('../../assets/image/images/default_media.jpg')"> -->
            </div>
            <div class="fl infos">
              <div class="name"
                   v-if="item.others.length">
                {{item.others[0]?(allPrice(item.others[0].standardEnName) ? formatPrice(item.others[0].standardData) : item.others[0].standardData):''}}
              </div>
              <div class="post"
                   v-if="item.others.length">
                {{item.others[1]?(allPrice(item.others[1].standardEnName) ? formatPrice(item.others[1].standardData) : item.others[1].standardData):''}}
              </div>
              <div class="info"
                   v-if="item.others.length">
                {{item.others[2]?(allPrice(item.others[2].standardEnName) ? formatPrice(item.others[2].standardData) : item.others[2].standardData):''}}
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ZImage from "../ZImage.vue"
export default {
  components: {
    ZImage
  },
  props: {
    tagsDataList: {
      type: Array
    },
    maxIndShow: {
      type: Number,
      default: 3
    }
  },
  data () {
    return {
      timeOutEvent: 0
    }
  },
  methods: {
    touchstarts (ind) {
      var _this = this;
      // 长按事件触发
      clearTimeout(_this.timeOutEvent);
      _this.timeOutEvent = setTimeout(function () {
        _this.timeOutEvent = 0;
        _this.$emit('emitContextMenuItem', ind);
      }, 400);
      //长按400毫秒
      // e.preventDefault();
    },
    touchmove: function () {
      clearTimeout(this.timeOutEvent);
      this.timeOutEvent = 0;
    },
    touchend: function (e) {
      clearTimeout(this.timeOutEvent);
      return false;
    }
  }
}
</script>

<style scoped>
.bottom-switch {
  padding: 18px 20px;
}
.bottom-switch .bottom-content {
  overflow: auto;
  height: 100%;
}
.bottom-content .sign-pic {
  width: 300px;
  /* width: 10px; */
  margin-right: 15px;
  position: relative;
  overflow: hidden;
}
.bottom-content .sign-pic img {
  display: block;
  border: 0;
  width: 100%;
  height: 100%;
}
.bottom-content .sign-pic .pic-tit {
  display: block;
  position: absolute;
  width: 280px;
  height: 286px;
  padding: 10px 20px;
  background: rgba(0, 0, 0, 0.6);
  top: 286px;
  left: 0px;
}
.bottom-content .sign-pic .pic-tit .tit {
  font-size: 18px;
  color: #fff;
  margin-bottom: 12px;
  display: block;
  white-space: nowrap;
  word-break: break-all;
  overflow: hidden;
  text-overflow: ellipsis;
}
.bottom-content .sign-pic .pic-tit .info {
  font-size: 12px;
  color: #999;
  display: block;
  white-space: nowrap;
  word-break: break-all;
  overflow: hidden;
  text-overflow: ellipsis;
}
.bottom-content .sign-pic .pic-tit .introduce {
  display: block;
  font-size: 12px;
  color: #999;
  margin-top: 10px;
  line-height: 20px;
  max-height: 40px;
  overflow: hidden;
}
.bottom-content .sign-pic a {
  display: block;
  height: 100%;
}
.bottom-content .sign-pic a:hover .pic-tit {
  top: 200px;
  transition: 0.3s;
}
.bottom-content .rows {
  width: -moz-calc(100% - 335px);
  width: -webkit-calc(100% - 335px);
  width: calc(100% - 335px);
  height: 100%;
  overflow: hidden;
}
.bottom-content .rows .row {
  border-bottom: 1px dashed #ddd;
  margin-bottom: 10px;
}
.bottom-content .rows .row:last-of-type {
  border: 0 none;
  padding-bottom: 0;
  margin-bottom: 0;
}
.bottom-content .rows .row .pic {
  width: 86px;
  height: 92px;
  margin-right: 10px;
}
.bottom-content .rows .row .pic img {
  display: block;
  border: 0;
  width: 86px;
  height: 92px;
}
.bottom-content .rows .row .infos {
  width: -moz-calc(100% - 124px);
  width: -webkit-calc(100% - 124px);
  width: calc(100% - 124px);
}
.bottom-content .rows .row .infos .name {
  margin-top: 4px;
  font-size: 18px;
  line-height: 26px;
  color: #333;
  display: block;
  white-space: nowrap;
  word-break: break-all;
  overflow: hidden;
  text-overflow: ellipsis;
}
.bottom-content .rows .row .infos .post {
  font-size: 14px;
  color: #999;
  line-height: 24px;
  height: 24px;
  margin: 8px 0 5px 0;
  display: block;
  white-space: nowrap;
  word-break: break-all;
  overflow: hidden;
  text-overflow: ellipsis;
}
.bottom-content .rows .row .infos .info {
  font-size: 12px;
  color: #999;
  line-height: 20px;
  height: 40px;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  text-overflow: ellipsis;
  display: -webkit-box;
  word-break: break-all;
}
.bottom-content .rows .row a {
  display: block;
}
.bottom-content .rows .row a:hover .infos .name {
  color: #2f8eed;
}

/* 超小屏幕（手机，小于 768px） */
@media screen and (min-width: 384px) and (max-width: 768px) {
  .bottom-switch .bottom-content {
    overflow: hidden;
    height: 100%;
  }
  #smart-intel-product
    .outreach_content
    .block-content
    .right-content
    .bottom-switch.smartAppSameScreenShow.expertsAlliance {
    height: auto;
  }
  .bottom-content .sign-pic .pic-tit {
    width: 100%;
  }
  .bottom-content .sign-pic {
    margin-right: 0;
    width: 100%;
  }
  .bottom-content .rows {
    margin-top: 15px;
    width: 100%;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/floorBlock/expert.vue